export type ChatNotificationPrefs = {
  sound: boolean
  desktop: boolean
}

const defaults: ChatNotificationPrefs = { sound: true, desktop: true }

let cache: ChatNotificationPrefs = { ...defaults }
let loaded = false
let loadPromise: Promise<ChatNotificationPrefs> | null = null

function normalize(raw: Partial<ChatNotificationPrefs> | null | undefined): ChatNotificationPrefs {
  return {
    sound: raw?.sound !== false,
    desktop: raw?.desktop !== false,
  }
}

function tenantHeaders(): HeadersInit {
  const tenantId = typeof window !== 'undefined' ? localStorage.getItem('tenantId') : null
  return tenantId ? { 'X-TenantId': tenantId } : {}
}

/** Anlık okuma — bildirim handler'ları için; önce loadChatNotificationPrefs çağrılmalı. */
export function readChatNotificationPrefs(): ChatNotificationPrefs {
  return cache
}

export function writeChatNotificationPrefs(prefs: ChatNotificationPrefs) {
  cache = normalize(prefs)
  if (typeof window === 'undefined') return
  void fetch('/api/opas/tenant/chat-notification-prefs', {
    method: 'PATCH',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...tenantHeaders() },
    body: JSON.stringify(cache),
  }).catch(() => {})
}

/** Sunucudan tercihleri yükler; tekrar çağrıda aynı promise döner. */
export function loadChatNotificationPrefs(): Promise<ChatNotificationPrefs> {
  if (typeof window === 'undefined') return Promise.resolve(defaults)
  if (loaded) return Promise.resolve(cache)
  if (loadPromise) return loadPromise

  loadPromise = fetch('/api/opas/tenant/chat-notification-prefs', {
    credentials: 'include',
    headers: tenantHeaders(),
    cache: 'no-store',
  })
    .then(async (res) => {
      if (res.ok) {
        const data = (await res.json()) as Partial<ChatNotificationPrefs>
        cache = normalize(data)
      }
      loaded = true
      return cache
    })
    .catch(() => {
      loaded = true
      return cache
    })
    .finally(() => {
      loadPromise = null
    })

  return loadPromise
}

export function getDefaultChatNotificationPrefs(): ChatNotificationPrefs {
  return { ...defaults }
}
